import { notification } from 'antd';
import { safeJSONParse } from '../helper';

const STATUS_CONFIGS = {
	new: { color: 'bg-blue-100 text-blue-800 border-blue-200', text: 'New' },
	'in-progress': { color: 'bg-orange-100 text-orange-800 border-orange-200', text: 'In Progress' },
	qualified: { color: 'bg-green-100 text-green-800 border-green-200', text: 'Qualified' },
	closed: { color: 'bg-gray-100 text-gray-800 border-gray-200', text: 'Closed' },
} as const;

const SENTIMENT_CONFIGS = {
	Positive: { color: 'bg-green-100 text-green-800' },
	'Very Positive': { color: 'bg-green-100 text-green-800' },
	Neutral: { color: 'bg-gray-100 text-gray-800' },
	Negative: { color: 'bg-red-100 text-red-800' },
	Frustrated: { color: 'bg-red-100 text-red-800' },
	'N/A': { color: 'bg-gray-100 text-gray-800' },
} as const;

const TEXT_STATUS_COLORS = {
	Active: 'bg-green-100 text-green-800',
	Urgent: 'bg-red-100 text-red-800',
	Pending: 'bg-yellow-100 text-yellow-800',
	Closed: 'bg-gray-100 text-gray-800',
} as const;

const PRIORITY_COLORS = {
	High: 'bg-red-100 text-red-800',
	Medium: 'bg-orange-100 text-orange-800',
	Low: 'bg-green-100 text-green-800',
} as const;

export const getStatusConfig = (status: string) => {
	return STATUS_CONFIGS[status as keyof typeof STATUS_CONFIGS] || STATUS_CONFIGS.closed;
};

export const getSentimentConfig = (sentiment: string) => {
	return (
		SENTIMENT_CONFIGS[sentiment as keyof typeof SENTIMENT_CONFIGS] || SENTIMENT_CONFIGS['Neutral']
	);
};

export const getTextStatusColor = (status: string) => {
	return (
		TEXT_STATUS_COLORS[status as keyof typeof TEXT_STATUS_COLORS] || TEXT_STATUS_COLORS['Closed']
	);
};

export const getPriorityColor = (priority: string) => {
	return PRIORITY_COLORS[priority as keyof typeof PRIORITY_COLORS] || PRIORITY_COLORS['Low'];
};

export const formatCamelCase = (str: string) => {
	return str.replace(/([A-Z])/g, ' $1').replace(/^./, (char) => char.toUpperCase());
};

export const showNotification = (
	type: 'success' | 'error' | 'info' | 'warning',
	message: string,
	description?: string,
) => {
	notification[type]({
		message,
		description,
		placement: 'topRight',
		className: 'shadow-lg border border-gray-200',
	});
};

export const hasValidAnswers = (form: Record<string, any>) => {
	return Object.values(form).some((answer) => {
		if (answer === null || answer === undefined) {
			return false;
		}
		const cleaned = String(answer).trim().toLowerCase();
		return cleaned && cleaned !== 'n/a' && cleaned !== 'undefined' && cleaned !== 'null';
	});
};

export const parseIntakeResponses = (intakeResponses?: string) => {
	if (!intakeResponses) {
		return null;
	}

	const parsed = safeJSONParse(intakeResponses, {});
	const form = Array.isArray(parsed) ? parsed[0] : parsed;

	if (!form || typeof form !== 'object' || Object.keys(form).length === 0) {
		return null;
	}

	if (!hasValidAnswers(form)) {
		return null;
	}

	return form;
};
